import React from 'react'
import { useSelector } from 'react-redux'
import { selectSelectedAdressAsFavorite } from '../../../../store/address/address.selectors'
import { TAG_CLICK_USER_FAVORITES_BUTTON } from '../../../analytics/analytics.tagids.constants'
import { selectCurrentGeoentityAsFavorite } from '../../../../store/geoentity/geoentity.selectors'
import { MODAL_IDS } from '../../../../store/ui/ui.constants'
import { addUserOtherFavorite, deleteUserFavorite } from '../../../../store/userAccount/userAccount.actions'
import {
  selectFavoriteByCurrentPoiId,
  selectFavoriteBySelectedAddress,
  selectIsUserAccountEnabled,
  selectIsUserConnected,
  selectUserFavoritesLimitNotReached
} from '../../../../store/userAccount/userAccount.selectors'
import { ACTION } from '../../../analytics/ClickTagsService'
import analyticsConstants from '../../../analytics/analytics.constants'
import CircledButtonWithLabel, { LogoVariants } from '../../../genericComponents/CircledButtonWithLabel'
import TagActionButton from '../../../genericComponents/TagActionButton'
import useModal from '../../../ui/useModal'
import { useAction } from '../../../utils/react-redux'
import UserFavoriteError from './UserFavoriteError'
import RectangleActionButton, {
  COLOR_GREY_EMPTY,
  SIZE_MEDIUM
} from '../../../genericComponents/buttons/RectangleActionButton'
import { isPE } from '../../../Device'
import heartIconUrl from '../../../genericComponents/assets/heart-favorite.svg'
import heartActiveIconUrl from '../../../genericComponents/assets/heart-favorite-active.svg'

const FavoriteButton = ({ favoriteSelector, transformFavoriteSelector, rectangleButton = false }) => {
  const canStillAddFavorite = useSelector(selectUserFavoritesLimitNotReached)
  const isUserAccountAvailable = useSelector(selectIsUserAccountEnabled)
  const isConnected = useSelector(selectIsUserConnected)
  const execAddUserOtherFavorite = useAction(addUserOtherFavorite)
  const execDeleteUserFavorite = useAction(deleteUserFavorite)
  const { displayModal } = useModal(MODAL_IDS.USER_ACCOUNT_INCENTIVE_POPIN)
  const favorite = useSelector(favoriteSelector)
  const isFavorite = Boolean(favorite)
  const poiOrAddressAsFavorite = useSelector(transformFavoriteSelector)
  const iconUrl = isFavorite ? heartActiveIconUrl : heartIconUrl
  const label = isFavorite ? 'useraccount.favorite.delete' : 'useraccount.favorite.add'
  const logoVariant = isFavorite ? LogoVariants.sharpGreenBorder : LogoVariants.sharpDarkGreyBorder
  const shouldDisplayIncentivePopin = isUserAccountAvailable && !isConnected

  const action = () => {
    if (shouldDisplayIncentivePopin) {
      displayModal()
    } else if (isFavorite) {
      execDeleteUserFavorite(favorite)
    } else {
      execAddUserOtherFavorite(poiOrAddressAsFavorite)
    }
  }

  const getTagAction = () => {
    const { cardAdd, cardAddIncentive, cardDelete } = analyticsConstants.user.favorites.action

    if (shouldDisplayIncentivePopin) return cardAddIncentive

    return isFavorite ? cardDelete : cardAdd
  }

  if (!isFavorite && !canStillAddFavorite) return <></>

  return (
    <span>
      {rectangleButton ? (
        <RectangleActionButton
          iconUrl={iconUrl}
          label={label}
          color={COLOR_GREY_EMPTY}
          size={SIZE_MEDIUM}
          onClick={action}
          deferClick
          tagData={{
            type: TAG_CLICK_USER_FAVORITES_BUTTON,
            tagInfo: {
              [ACTION]: getTagAction()
            }
          }}
        />
      ) : (
        <TagActionButton
          onClick={action}
          deferClick
          type={TAG_CLICK_USER_FAVORITES_BUTTON}
          tagInfo={{
            [ACTION]: getTagAction()
          }}
        >
          <CircledButtonWithLabel svgUrl={iconUrl} label={label} logoVariant={logoVariant} />
        </TagActionButton>
      )}

      <UserFavoriteError />
    </span>

  )
}

export const AddressFavoriteButton = () => (
  <FavoriteButton
    transformFavoriteSelector={selectSelectedAdressAsFavorite}
    favoriteSelector={selectFavoriteBySelectedAddress}
  />
)

export const GeoentityFavoriteButton = () => (
  <FavoriteButton
    transformFavoriteSelector={selectCurrentGeoentityAsFavorite}
    favoriteSelector={selectFavoriteByCurrentPoiId}
    rectangleButton={isPE()}
  />
)
